import { UI } from '@Modules/UI';
import approveStatusHelper from '@Helpers/approveStatus';

export const mockupsPanels = [
  { key: 'Front', title: 'Front' },
  { key: 'Back', title: 'Back' },
  { key: 'LeftSleeve', title: 'Left Sleeve' },
  { key: 'RightSleeve', title: 'Right Sleeve' }
];

export const artworkPlacement = [
  {
    label: 'Center-Center',
    value: 'Center'
  },
  {
    label: 'Center-Left',
    value: 'MeddleLeft'
  },
  {
    label: 'Center-Right',
    value: 'MeddleRight'
  },
  {
    label: 'Top-Center',
    value: 'TopCenter'
  },
  {
    label: 'Top-Left',
    value: 'TopLeft'
  },
  {
    label: 'Top-Right',
    value: 'TopRight'
  },
  {
    label: 'Bottom-Center',
    value: 'BottomCenter'
  },
  {
    label: 'Bottom-Left',
    value: 'BottomLeft'
  },
  {
    label: 'Bottom-Right',
    value: 'BottomRight'
  },
];

export const printArea = [
  {
    label: 'Optimal',
    value: 'Optimal'
  },
  {
    label: 'Full',
    value: 'Full'
  },
];

export const colorGroups = {
  All: 0,
  Light: 1,
  Dark: 2,
  Black: 3,
};

export const artworkType = {
  central: 'Central',
  pattern: 'Pattern',
  complex: 'Complex'
};

export const TABLE_COLUMNS = {
  BLANKS: [
    {
      data: null,
      width: 30,
      defaultContent: '',
      className: 'control',
      orderable: false,
      sortable: false,
      responsivePriority: 0
    },
    {
      title: $Lang.artwork.SelectedBlanks,
      data: 'imageExistsUri',
      render: (data, type, full) => {
        return `<div class="d-flex align-items-center">${UI.thumbnail(
          data
        )}<div class="pl-3" data-aid="artwork-selected-blanks">${full.title}</div></div> `;
      }
    },
    {
      title: $Lang.artwork.CategorySubCategory,
      data: 'category',
      render: (data, type, full) => {
        return `<div data-aid="artwork-blanks-category">${data}${
          full.subCategory && full.subCategory != null
            ? '<i class="fal fa-angle-right mx-2"></i>' + full.subCategory
            : ''
        }</div>`;
      }
    },
    {
      title: $Lang.artwork.DefaultMockupPanel,
      data: '',
      render: (data, type, full) => {
        let options = '';
        let selectedMockupPanel = full.defaultMockupPanel;

        if (!selectedMockupPanel) {
          selectedMockupPanel = mockupsPanels[0].key; // By default Front
        }

        mockupsPanels.forEach((sp) => {
          const selected = sp.key === selectedMockupPanel ? 'selected' : '';
          return (options += '<option ' + selected + ' value="' + sp.key + '">' + sp.title + '</option>');
        });

        return `<select
            class="form-control mockup-select"
            style="width:175px;"
            data-lineiteminstoreid='${full.id}'
            id="selectedMockupDropdown-${full.id}">
              ${options}
          </select>`;
      }
    },

    {
      title: $Lang.artwork.Brand,
      data: 'brand',
      render: (data, type, full) => {
        return `<div data-aid="artwork-blanks-brand">${data}</div>`;
      }
    },
    {
      title: $Lang.artwork.BrandCode,
      data: 'brandCode',
      render: (data, type, full) => {
        return `<div data-aid="artwork-blanks-brand-code">${data}</div>`;
      }
    },
    {
      title: $Lang.artwork.Statuses,
      data: 'approveItem',
      render: (data, type, full) => {
        let out = '';
        out += `<div class="d-inline-block text-success mr-4" data-aid="artwork-blanks-status-selected"><i class="fa${
          full.selectedStatus == 'Selected' ? 'r' : ''
        } fa-check-circle"></i> ${full.selectedStatus}</div> `;
        out += approveStatusHelper('blanks', data);
        return out;
      }
    },
    {
      title: $Lang.artwork.SelectedColors,
      data: null,
      render: (data, type, full) => {
        let out = '';
        full.variants
          .filter((f) => f.select)
          .forEach((variant) => {
            out += `<span class="d-inline-block kt-badge--bbw-color" style="background-color:${
              variant.colorHex != '' ? variant.colorHex : variant.color
            }" data-aid="artwork-blanks-selected-colors"></span> `;
          });
        return out;
      }
    }
  ]
};

export const colorGroupsMap = {
  All: 'All',
  Light: 'Light',
  Dark: 'Dark',
  Black: 'Black',
  SpecificColors: 'Specific colors (to be defined at the product level)'
};
